import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router"

export const Route = createFileRoute("/_authenticated/$slug/admin")({
  staticData: { title: "Admin" },
  component: lazyRouteComponent(
    () => import("#pages/authenticated/admin/layout.tsx"),
    "AdminLayout",
  ),
})
